var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.964627 0C0.804923 0 0.637917 0.0537151 0.516032 0.175503C0.272325 0.419702 0.272325 0.829401 0.516032 1.0736L4.43612 4.99641L0.516032 8.91922C0.272325 9.16342 0.272325 9.57312 0.516032 9.81732C0.759801 10.0609 1.16945 10.0609 1.41322 9.81732L5.33325 5.89452L9.25328 9.81732C9.49705 10.0609 9.9067 10.0609 10.1505 9.81732C10.3942 9.57312 10.3942 9.16342 10.1505 8.91922L6.23038 4.99641L10.1505 1.0736C10.3942 0.829401 10.3942 0.419702 10.1505 0.175503C10.0286 0.0537151 9.86152 0 9.70188 0C9.54217 0 9.37523 0.0537151 9.25328 0.175503L5.33325 4.0983L1.41322 0.175503C1.29134 0.0537151 1.12433 0 0.964627 0Z",
    fill: "var(--gray-40)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.ecc21db3542d750a75b9ff1cbb96a445.svg";
export { ForwardRef as ReactComponent };